var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#E62C28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2344 17.8594C35.9531 16.7344 35.0625 15.8438 33.9844 15.5625C31.9688 15 24 15 24 15C24 15 15.9844 15 13.9688 15.5625C12.8906 15.8438 12 16.7344 11.7188 17.8594C11.1562 19.8281 11.1562 24.0469 11.1562 24.0469C11.1562 24.0469 11.1562 28.2188 11.7188 30.2344C12 31.3594 12.8906 32.2031 13.9688 32.4844C15.9844 33 24 33 24 33C24 33 31.9688 33 33.9844 32.4844C35.0625 32.2031 35.9531 31.3594 36.2344 30.2344C36.7969 28.2188 36.7969 24.0469 36.7969 24.0469C36.7969 24.0469 36.7969 19.8281 36.2344 17.8594ZM21.375 27.8438V20.25L28.0312 24.0469L21.375 27.8438Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeHovered);
export default __webpack_public_path__ + "static/media/youtube_hovered.91e64f8afec31a0fdb7e5b4209674797.svg";
export { ForwardRef as ReactComponent };